export const constant = {
  Application_Settings: 'Application Settings',
  LogOut: 'Log Out'
};
